module.exports = _.omitBy;